<template>
    <f7-page name="ua-personal-detail" id="ua-personal-detail" class="bg-color-white" @page:afterin="afterin">
        <f7-navbar class="view-mobile">
          <f7-nav-left class="back-button">
            <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
          </f7-nav-left>
          <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <f7-block>
            <ul class="step-nav">
                <li class="active"></li>
                <li class="active"></li>
                <li class="active" v-if="isIncludePOA()"></li>
                <li class="active"></li>
            </ul>
            <div class="wandr-title-1 mb-md">{{ $t('ua-personal-detail-title') }}</div>
            <p>{{ $t('ua-personal-detail-desc') }}</p>

            <CustomerFullname
              :key="keyFullname"
              @validateNextButton="validateNextButton"
              @setInputValue="setInputValue"
            />

            <CustomerNationality
              :key="keyNationality"
              :countryList="countryList"
              @validateNextButton="validateNextButton"
            />

            <CustomerGender :key="keyGender" @validateNextButton="validateNextButton" />
            <CustomerDob :key="keyDob" @validateNextButton="validateNextButton" />
            <CustomerIdType
              :key="keyIdType"
              :docTypeList="docTypeList"
              @validateNextButton="validateNextButton"
            />


            <f7-list form class="form-group">
                <f7-list-input
                  input-id     ="idNo"
                  name         ="idNo"
                  type          ="text"
                  class         =""
                  :label       ="$t('ua-id-number')"
                  placeholder  =""
                  :value       ="updateDetails.idNo"
                  @input       ="setInputValue($event.target)"
                  autocomplete  ="off"
                  outline
                  floating-label
                  required
                  clear-button
                >
                </f7-list-input>

                <f7-list-input
                  input-id      ="employment"
                  id            ="industry-list"
                  name          ="employment"
                  type          ="text"
                  class         =""
                  placeholder   =""
                  :value        ="updateDetails.employmentSector"
                  :label       ="$t('ua-employment-sector')"
                  autocomplete  ="off"
                  outline
                  floating-label
                  required
                  clear-button
                ></f7-list-input>
            </f7-list>

            <div id="account-occupation">
              <f7-list class="form-group">
                <f7-list-input
                  input-id      ="occupation"
                  id            ="occupation-list"
                  name          ="occupation"
                  type          ="text"
                  class         =""
                  placeholder   =""
                  :value        ="updateDetails.occupation"
                  :label         ="$t('regis-occupation')"
                  autocomplete  ="off"
                  v-show        ="true"
                  outline
                  floating-label
                  required
                  :disabled    = "false"
                  clear-button
                ></f7-list-input>
              </f7-list>
              <div class="view-mobile" style="color: transparent">-</div>
            </div>

            <f7-button @click="submitForm" large fill round :disabled="false" class="view-desktop my-5">
                {{$t('general-text-continue')}}
            </f7-button>
        </f7-block>
        <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
            <f7-button @click="submitForm" large fill round :disabled="false">
                {{$t('general-text-continue')}}
            </f7-button>
        </f7-toolbar>
    </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import CustomerFullname from '../../components/account-name.vue';
  import CustomerNationality from '../../components/account-nationality.vue';
  import CustomerGender from '../../components/account-gender.vue';
  import CustomerDob from '../../components/account-dob.vue';
  import CustomerIdType from '../../components/account-idtype.vue';
  import { debounce } from 'lodash'; 
  export default {
    mounted (){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })

      this.init();
    },
    data() {
      return {
        isFormInputValid : false,
        countryList      : [],
        docTypeList      : [],
        fullname         : "",
        nationality      : {id: 0, name: ''},
        gender           : "M",
        dob              : "",
        idType           : {id: 0, name: ''},
        idNo             : "",
        occupation       : "",
        employment       : "",


        keyFullname      : 0,
        keyNationality   : 1000,
        keyGender        : 2000,
        keyDob           : 3000,
        keyIdType        : 4000,
        keyIdNo          : 5000,
        keyOccupation    : 6000,
        keyEmpoymentSector: 7000,
      }
    },
    methods: {
      ...mapActions('auth', ['login']),
      ...mapActions('staticData', ['getCountryList', 'getOccupationList', 'getIndustryList']),
      ...mapActions('customer', [
        'validateInput',
        'updateCustomerDetail',
        'setOccupationList',
        'setUpdateCustomerName',
        'setUpdateNationality',
        'setUpdateGender',
        'setUpdateDob',
        'setUpdateIdType',
        'setUpdateIdNo',
        'setUpdateOccupation',
        'setUpdateEmploymentSector',
        'setUpdateIndustryList',
        'setIsModifyAlias',
      ]),
      ...mapActions('ekycService', ['uploadEkycDocs', 'getEkycTypeList']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async init(){
        const self = this;
        self.$f7.calendar.create({
          inputEl: '#dob',
          openIn: 'popup',
          dateFormat: "dd-mm-yyyy",
          closeOnSelect: true,
          disabled: {
              from: new Date(2015, 11, 1)
          },
        })

        // SET FULLNAME
        self.setIsModifyAlias(false)
        let custFullname = self.$store.state.customer.customerName;
        if(custFullname.trim().toLowerCase() == "customer"){ // RESET FULLNAME IF NAME = "Customer"
          custFullname = "";
        }
        await self.setUpdateCustomerName(custFullname);
        self.keyFullname += 1 // RE-RENDER COMPONENT


        // SET NATIONALITY
        await self.setUpdateNationality({id: self.$store.state.customer.nationalityId, name: self.$store.state.customer.nationality})
        self.keyNationality += 1 // RE-RENDER COMPONENT

        // SET GENDER
        await self.setUpdateGender(self.$store.state.customer.gender)
        self.keyGender += 1 // RE-RENDER COMPONENT

        // SET DoB
        // if(self.$store.state.customer.dob.trim() == ""){ // DOB NULL
        //   // SET TO DEFAULT
        //   //console.log("null dob or invalid value : "+self.$store.state.customer.dob);
        //   await self.setUpdateDob("01-01-1950")
        //   self.keyDob += 1 // RE-RENDER COMPONENT
        // }else{
        //   const moment= require('moment');
        //   const maxDate = moment().subtract(18, 'years').format('DD-MM-YYYY'); // MIN 18 y.o
        //   const oldDob = moment(new Date(self.$store.state.customer.dob)).format('DD-MM-YYYY');

        //   if(oldDob > maxDate){ // < 18 y.o
        //     // SET TO DEFAULT
        //     await self.setUpdateDob("01-01-1950")
        //   }else{
            var d = new Date(self.$store.state.customer.dob),
                  month = '' + (d.getMonth() + 1),
                  day = '' + d.getDate(),
                  year = d.getFullYear();

              if (month.length < 2)
                  month = '0' + month;
              if (day.length < 2)
                  day = '0' + day;

            const formattedDob =  [day, month, year].join('-');
            //console.log("cust dob : "+formattedDob)
            await self.setUpdateDob(formattedDob=='01-01-1950'?'':formattedDob)
          // }
          self.keyDob += 1 // RE-RENDER COMPONENT
        // }

        // SET ID TYPE
        self.keyIdType += 1 // RE-RENDER COMPONENT

        // CLEAR ID NUMBER
        await self.setUpdateIdNo("");

        // SET OCCUPATION
        await self.setUpdateOccupation(self.$store.state.customer.occupation)

        await self.getCountryList();
        await self.getOccupationList();
        await self.renderAutoComplete("industry");
        await self.getEkycTypeList();
        //await self.finalValidationBeforeSubmit();

        // AUTOCOMPLETE CLEAR BUTTON LISTENER
        self.Dom7("#occupation").on('input:clear', function (e) {
          //console.log("occupation cleared")
          e.preventDefault();
          e.stopImmediatePropagation();
          self.Dom7("#occupation").val('').trigger('input change')
          
          const app = self.$f7
          app.autocomplete.close("#occupation")
        })

        self.Dom7("#employment").on('input:clear', function (e) {
          //console.log("employment cleared")
          e.preventDefault();
          e.stopImmediatePropagation();
          self.Dom7("#employment").val('').trigger('input change')
          
          const app = self.$f7
          app.autocomplete.close("#employment")
        })
      },
      isIncludePOA(){
        return this.updateDetails.idTypeId != process.env.VUE_APP_DOCUMENT_ID_EKYC_NATIONAL_ID;
      },
      async getCountryList() {
        const self = this;
        this.showPreloader();
        this.$api.staticData.getCountryList().then(function(result) {
          //console.log("nationalities: ", result)
          self.countryList = result.filter(country => country.isHidden == false);

          //self.countryList = result.filter(country => country.isHidden == false && country.countryId != 189);

          self.countryList.forEach(function(item,i){
            if(item.countryId === 189){
              self.countryList.splice(i, 1);
              self.countryList.unshift(item);
            }
          });

          self.hidePreloader();
        });
      },

      async getOccupationList() {
        const self = this;
        const occupationListPromise = await self.$api.staticData.getOccupationList();
        await self.setOccupationList(occupationListPromise);
        self.occupationListState = occupationListPromise;
        console.log("occupation list stored")
        await self.renderAutoComplete("occupation");
      },

      renderAutoComplete(el){
        const self = this;
        const app          = self.$f7;
        const $$            = self.Dom7;

        if(el == "occupation"){
          const occList = self.occupationList;
          self.selectedOccupation = self.updateDetails.occupation;
          self.autocompleteOccupation = app.autocomplete.create({
              inputEl: '#occupation',
              openIn: 'dropdown',
              class  : '',
              closeOnSelect: true,
              source: async function (query, render) {
                  self.selectedOccupation = query;
                  await self.setUpdateOccupation(query);
                  //await self.validateInput({id: "occupation"});
                  await self.validateNextButton();

                  let results = [];
                  if(query.length <= 2) {
                      app.autocomplete.close("#occupation")
                      return;
                  }
                  if(query.length === 0) {
                      render(results);
                      return;
                  }
                  // Find Matched Items
                  Object.keys(occList).forEach(key => {
                      if(occList[key].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                          results.push(occList[key]);
                      }
                  })

                  // Render Items By Passing Array With Result Items
                  render(results.sort());
                  $$("#account-occupation").removeClass("pb-200").addClass("pb-200")
                  app.autocomplete.open("#occupation")
              },
              on: {
                change: function (e) {
                  self.selectedOccupation = e[0];
                  self.setUpdateOccupation(e[0])
                  //self.occupation = e[0];
                  self.validateInput({id: "occupation"})
                  self.validateNextButton()                 

                  self.Dom7("#occupation").val(e[0]).trigger('input blur')
                },
                closed: function () {
                  //self.setOccupation(e.value[0])'
                  console.log("autocomplete dropdown closed")
                  $$("#account-occupation").removeClass("pb-200")
                },
                opened(e){
                  //console.log(e)
                  if(e.items){
                    //console.log("items : "+e.items.length)
                    $$("#account-occupation").removeClass("pb-200").addClass("pb-200")
                  }else{
                    //console.log("no items")
                    $$("#account-occupation").removeClass("pb-200")
                  }
                }
              }
          });
        }else if(el == "industry"){
          self.Dom7("#employment").on("focus", async function() {
              // GET INDUSTRY LIST BY OCCUPATION
              const industryListPromise = await self.$api.staticData.getIndustryList("ekyc");

              if(industryListPromise.status == "0429"){
                await self.setUpdateIndustryList(industryListPromise.result);
              }

              if(self.updateDetails.industryList.key){
                await self.setUpdateEmploymentSector(self.updateDetails.industryList.value)
                //await self.validateInput({id: "employment", value: self.updateDetails.industryList.value})
                await self.validateNextButton()
              }
          });


          self.autocompleteIndustry = app.autocomplete.create({
              inputEl: '#employment',
              openIn: 'dropdown',
              class  : '',
              closeOnSelect: true,
              source: async function (query, render) {
                  await self.setUpdateEmploymentSector(query);
                  //await self.validateInput({id: "employment", value: query})
                  await self.validateNextButton()

                  const employmentSectorList = self.updateDetails.industryList;

                  let results = [];
                  if(query.length === 0) {
                      render(results);
                      return;
                  }

                  // Find Matched Items
                  await Object.keys(employmentSectorList).forEach(key => {
                      if(employmentSectorList[key].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                          results.push(employmentSectorList[key]);
                      }
                  })

                  // Render Items By Passing Array With Result Items
                  render(results.sort());
                  app.autocomplete.open("#employment")
              },
              on: {
                change: async function (e) {
                  await self.setUpdateEmploymentSector(e[0])
                  await self.validateInput({id: "employment", value: e[0]})
                  await self.validateNextButton()

                  self.Dom7("#employment").val(e[0]).trigger('input blur')
                },
                closed: function(){
                  console.log("employmentSector autocomplete dropdown closed")
                },
                opened(e){
                  //console.log(e)
                  if(e.items){
                    console.log("total employment sector list : "+e.items.length)
                  }else{
                    console.log("employmentSector : no items")
                  }
                }
              }
          });

        }
      },

      async setOccupationDropDown() {
        const self = this;
        this.$f7.autocomplete.create({
          inputEl: '#occupation-autocomplete-dropdown',
          preloader: true,
          openIn: 'dropdown',
          source: function (query, render) {
            var autocomplete = this;
            autocomplete.preloaderShow();
            self.$api.staticData.getOccupationList(query.toLowerCase()).then(function(result) {
              autocomplete.preloaderHide();
              render(Object.values(result));
            });
          }
        });
      },
      async getEkycTypeList() {
        const self = this;
        this.showPreloader();
        this.$api.ekycService.getEkycTypeList().then(function(result) {
          console.log("doctype LIST : ", result)

          for (let i in result) {
            if(i == 'Others') {
              for (let j in result[i]) {
                self.docTypeList.push({id: result[i][j].key, name: result[i][j].value});
              }
            } else {
              self.docTypeList.push({id: result[i].key, name: result[i].value});
            }
          }

          self.docTypeList.forEach(function(item,x){
            if(item.id === "103"){
              self.docTypeList.splice(x, 1);
              self.docTypeList.unshift(item);
            }
          });

          self.docTypeList.forEach(function(item,x){
            if(item.id === "120"){
              self.docTypeList.splice(x, 1);
              self.docTypeList.unshift(item);
            }
          });

          self.docTypeList.forEach(function(item,x){
            if(item.id === "133"){
              self.docTypeList.splice(x, 1);
              self.docTypeList.unshift(item);
            }
          });

          self.docTypeList.forEach(function(item,x){
            if(item.id === "154"){
              self.docTypeList.splice(x, 1);
              self.docTypeList.unshift(item);
            }
          });

          self.docTypeList.forEach(function(item,x){
            if(item.id === "104"){
              self.docTypeList.splice(x, 1);
              self.docTypeList.unshift(item);
            }
          });


          self.hidePreloader();
        });
      },
      selectNationality(country) {
        this.nationality = {id: country.countryId, name: country.countryName};
        this.validateInput();
      },
      selectGender(gender) {
        this.gender = gender;
        this.validateInput();
      },
      selectDOB(element) {
        this.dob = element.value;
        this.validateInput();
      },
      setInputValue(el){
        const self         = this;
        const debouncedValue = debounce(function () {
            //console.log("element : ", el);
            if(el.id == "fullname"){
              self.setUpdateCustomerName(el.value);
              self.validateInput(el);
              self.validateNextButton()
            }else if(el.id == "idNo"){
              self.setUpdateIdNo(el.value);
              self.validateInput(el);
              self.validateNextButton()
            }else{
              console.log("element : ", el);
            }
        }, 500);

        debouncedValue();
      },

      validateNextButton(){
        this.isFormInputValid = this.isValidFullname && this.isValidNationality && this.isValidGender && this.isValidDob && this.isValidIdType && this.isValidIdNo && this.isValidOccupation && this.isValidEmploymentSector
      },
      validateInput_old() {
        this.isFormInputValid = (this.fullname !== '' && this.nationality.id !== 0 && this.idType.id !== 0 &&
                                this.dob !== '' && this.idNo !== '' && this.occupation !== '' && this.employment !== '');
      },
      async finalValidationBeforeSubmit(){
        console.log("FINAL VALIDATION")
        await this.validateInput({id: "fullname", value: this.updateDetails.customerName});
        await this.validateInput({id: "nationality"});
        await this.validateInput({id: "gender"});
        await this.validateInput({id: "dob"});
        await this.validateInput({id: "idType"});
        await this.validateInput({id: "idNo"});
        await this.validateInput({id: "occupation"});
        await this.validateInput({id: "employment"});
      },
      async submitForm() {
        const self = this;
        self.showPreloader();

        /*
        console.log("firstName: "+self.updateDetails.customerName)
        console.log("nationality: "+self.updateDetails.nationality)
        console.log("gender: "+self.updateDetails.gender)
        console.log("dob: "+self.updateDetails.dob)
        console.log("id type: "+self.updateDetails.idType)
        console.log("id no: "+self.updateDetails.idNo)
        console.log("occupation: "+self.updateDetails.occupation)
        console.log("employment: "+self.updateDetails.employmentSector)
        */

        await self.finalValidationBeforeSubmit();

        if(this.isValidForm){
          console.log("FORM VALID")

          //const dobDate = new Date(self.updateDetails.dob);
          //self.showPreloader();
          const customer = {
              email           : '',
              firstName       : self.updateDetails.customerName,
              nationalityId   : self.updateDetails.nationalityId,
              gender          : self.updateDetails.gender,
              dob             : self.updateDetails.dob, // ("0" + dobDate.getDate()).slice(-2) + "-" + ("0" + (dobDate.getMonth() + 1)).slice(-2) + "-" + dobDate.getFullYear() ,
              identificationNo: self.updateDetails.idNo,
              occupation      : self.updateDetails.occupation,
              employment      : self.updateDetails.employmentSector
          }

          const customerPromise = self.$api.customer.updateCustomerDetail(customer);
          const ekycPromise     = self.$api.ekycService.uploadEkycDocs(self.updateDetails.idTypeId, self.updateDetails.idNo, []);
          Promise.all([customerPromise, ekycPromise]).then((response)=>{
            const customerResponse = response[0];
            const ekycResponse = response[1];
            self.hidePreloader();
            if(customerResponse === undefined || customerResponse.length <= 0 || ekycResponse === undefined || ekycResponse.length <= 0) {
              self.$f7.dialog.alert(self.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
              return false;
            }

            self.$f7router.navigate("/verify/completed", { props: { isFromEKYC: true }});
          });
        }else{ // form invalid
          console.log("FORM INVALID")
          self.hidePreloader();
        }
      },
      backButton() {
        this.$f7router.back({ transition: 'f7-push' });
      }
    },
    components: {
      CustomerFullname,
      CustomerNationality,
      CustomerGender,
      CustomerDob,
      CustomerIdType
    },
    computed: {
      ...mapGetters('auth', [
          'authenticating',
          'authenticationError',
          'authenticationErrorCode',
          'authenticationSuccess'
      ]),
      ...mapGetters('customer', [
            'occupationList',
            'updateDetails',
            'isValidFullname',
            'isValidNationality',
            'isValidGender',
            'isValidDob',
            'isValidIdType',
            'isValidIdNo',
            'isValidOccupation',
            'isValidEmploymentSector',
            'isValidForm'
        ]),
    }
  }
</script>